import { getNilometer } from '../../../api/elasticSearch/nilometerApi'
import Utils from '../../../utils/utils'

const state = {
  niloData: [],
}
const getters = {
  getNiloData: state => {
    return state.niloData
  },
}
const actions = {
  async getNiloData({ commit }, condition) {
    commit('niloData', await getNilometer(condition))
  },
}
const mutations = {
  niloData(state, data) {
    state.niloData = data
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
